import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { TextMessage } from 'components/tt-forms/common';
import { connect } from 'react-redux';
import { GiaHanDialog, SuspendedDialog, TruongPhongThuHoiDialog, DeleteDialog } from 'modules/dialog';
import TextTruncate from 'react-text-truncate';
import { ShowIf } from 'components/utils';
import { CheckQuyenThaoTacXuLy } from 'modules/login/CheckQuyenThaoTacXuLy.js';
import { CheckQuyenTuXuLy } from 'modules/login/CheckQuyenTuXuLy';
import { CheckPermission } from 'modules/login/CheckPermission';

class ListTaiLieuRowItem extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      type: this.props.type,
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: ''
    }
  }

  componentDidMount() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

    if (this.props.item.trangThaiDonInfo) {
      this.props.item.trangThaiDonInfo.filter(item => {
        return item.donViId == userInfo.donViId;
      }).map((child, i) => {
        this.setState({
          ketQuaStr: child.ketQuaStr,
          ketQuaType: child.ketQuaType,
          trangThaiDonText: child.trangThaiDonText,
          trangThaiDonType: child.trangThaiDonType,
        });
      });
    }
  }

  getLocal(diachi) {
    let dungDon = [];
    if(diachi.diaChi) {
      dungDon.push(diachi.diaChi);
    }
    if(diachi.toThon) {
      dungDon.push(diachi.toThon);
    }
    if(diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
      dungDon.push(diachi.phuongXaCongDan.ten);
    }
    if(diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
      dungDon.push(diachi.quanHuyenCongDan.ten);
    }
    if(diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
      dungDon.push(diachi.tinhThanhCongDan.ten);
    }
    return dungDon.join(", ");
  }

  showThongTinCongDan() {
    let size = this.props.item.listNguoiDungDon.length;

    if (size) {
      return (
        <div>
          <li className="txt-bold">{this.props.item.listNguoiDungDon[0].hoVaTen}</li>
          <li>{this.getLocal(this.props.item.listNguoiDungDon[0])}</li>
          <li>{this.props.item.listNguoiDungDon[0].soDienThoai}</li>
        </div>
      )
    }
  }

  showThoiHanXuLyDon() {

    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let thoiHanXuLy = {};
    if (this.checkDonViTTXM() && this.state.ketQuaType == 'DANG_LAP_DU_THAO') {
      thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo
    } else if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {
      thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
    } else {
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
        thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      } else if (this.props.item.donViXuLyGiaiQuyetInfo && this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == userInfo.donViId) {

        this.props.item.trangThaiDonInfo.filter(item => {
          return item.donViId == userInfo.donViId;
        }).map((child, i) => {

          if (child.trangThaiDonType == 'DANG_XU_LY')
            thoiHanXuLy = this.props.item.thoiHanXuLyInfo;
          if (child.trangThaiDonType == 'DANG_GIAI_QUYET')
            thoiHanXuLy = this.props.item.thoiHanGiaiQuyetInfo;
        });
      }
    }

    if (thoiHanXuLy.type == 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy.type == 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  showThoiHanLapDuThao() {
    let thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo
    if (thoiHanXuLy.type == 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy.type == 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  getListData() {
    this.props.getListData();
  }

  checkNguonDon(type) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let nguonDonText = '';
    let nguonDonDonVi = '';
    let nguonDontype = '';
    let Return = '';
    if(this.props.item.nguonDonInfo) {
      let dataNguonDon = this.props.item.nguonDonInfo.filter(nguonDon => {
        return nguonDon.idDonVi == userInfo.donViId;
      });

      if (dataNguonDon.length > 0 ) {
        nguonDonText = dataNguonDon[0].nguonDonText;
        nguonDonDonVi = dataNguonDon[0].donViChuyenText;
        nguonDontype = dataNguonDon[0].type;
      } else {
        nguonDonText = this.props.item.nguonDonText;
        nguonDonDonVi = '';
        nguonDontype = '';
      }
    }
    if (type == 'nguonDonText') {
      Return = nguonDonText
    }
    if (type == 'nguonDonDonVi') {
      Return = nguonDonDonVi
    }
    if (type == 'nguonDontype') {
      Return = nguonDontype
    }
    return Return;
  }

  checkAllowHandle(){
    let pass = CheckQuyenThaoTacXuLy(this.props.item.canBoDangXuLyInfo);
    return pass;
  }

  getThoiHanThamTraXacMinh() {
    let thoiHanXuLy = this.props.item.thoiHanTTXMInfo
    if (thoiHanXuLy.type == 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy.type == 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  checkQuyenBoSungThongTin() {
    let data = [...this.props.item.listLichSuCanBoXuLy];
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let dataCheck = data.filter(state => {
      return state.congChucId == userInfo.id
    })

    if(dataCheck.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  checkDonViTTXM() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
      return true
    } else {
      return false
    }
  }

  render() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let dataNguonDon = this.props.item.trangThaiDonInfo.filter(nguonDon => {
      return nguonDon.donViId == userInfo.donViId;
    });

    let allowHandle = this.checkAllowHandle();

    let donId = this.props.item.donId;
    let linkToDetailPage = '/giai-quyet-don/chi-tiet/' + donId;
    let linkToHandle = '/giai-quyet-don/giai-quyet/' + donId;
    let donDate = this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
    let donTime = this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('HH:mm') : '';
    let thongTinCongDan = this.showThongTinCongDan();
    let nguonDonText = this.checkNguonDon('nguonDonText');
    let nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
    let nguonDontype = this.checkNguonDon('nguonDontype');

    let loaiDonThu = this.props.dataLoaiDonThu.filter(state => {
      return state.giaTri == this.props.item.loaiDon
    })
    let showDelete = this.props.item.donViXuLyGiaiQuyetInfo && userInfo.donViId == this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId;
    let listCanBoGiaiQuyet = this.props.item.canBoDangXuLyInfo.filter(state => {
      return state.donViId == userInfo.donViId;
    });

    let trangThaiDon = this.props.item.trangThaiDonInfo.filter(state => {
      return state.donViId == userInfo.donViId
    });
    return (
      <tr ref='itemGQD'>
        <td>{this.props.count}</td>
        <td>{this.props.item.ma ? this.props.item.ma : ''}</td>
        <td>
          <ul className="list-items-table">
            <li>{donDate}</li>
            <li>{donTime}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            {thongTinCongDan}
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              <Link
                className="txt-underline"
                to={linkToDetailPage} >
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={this.props.item.noiDung}
                />
              </Link>
            </li>
            <ShowIf condition={
              (!this.checkDonViTTXM() || (trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM' && trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM_LAI')) &&
              (!this.checkDonViTTXM() || (trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DA_LAP_DU_THAO')) &&
              (trangThaiDon[0].ketQuaType !='LUU_HO_SO')
            }>
              <li>{this.showThoiHanXuLyDon()}</li>
            </ShowIf>
            <li>{this.props.item.lyDoQuaHan}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              {loaiDonThu.length > 0 ? loaiDonThu[0].ten : ''}
            </li>
            <li>{this.props.item.soNguoi ? (this.props.item.soNguoi + ' người') : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <ShowIf condition={nguonDonDonVi != '' && nguonDonDonVi != null}>
              <li className="txt-italic">{nguonDonDonVi}</li>
            </ShowIf>
            <li>{nguonDonText}</li>
          </ul>
        </td>
        <td>{this.props.item.coQuanDaGiaiQuyetDonThu || ''}</td>
        <td>
          <ul className="list-items-table">
            <ShowIf condition={dataNguonDon.length > 0}>
              <li>{dataNguonDon.length > 0 ? dataNguonDon[0].trangThaiDonText : ''}</li>
            </ShowIf>
            <ShowIf condition={dataNguonDon.length > 0}>
              <li><TextMessage className='txt-italic col-100 no-gutter txt-left' value={dataNguonDon.length > 0 ? (dataNguonDon[0].ketQuaType == 'DINH_CHI' ? 'Đình chỉ' : dataNguonDon[0].ketQuaStr) : ''}/></li>
            </ShowIf>
            <ShowIf condition={this.state.ketQuaType == 'DANG_TTXM' && !this.checkDonViTTXM()}>
              <li>{this.getThoiHanThamTraXacMinh()}</li>
            </ShowIf>
            <ShowIf condition={this.state.ketQuaType == 'DANG_LAP_DU_THAO' && !this.checkDonViTTXM()}>
              <li>{this.showThoiHanLapDuThao()}</li>
            </ShowIf>
          </ul>
        </td>
        <td>{listCanBoGiaiQuyet.length > 0 ? listCanBoGiaiQuyet[0].hoVaTen : ''}</td>
        <td>
          <div className="todo-wrap two-item">
            <ShowIf condition= {this.props.item.huongXuLyXLD != 'DINH_CHI' && (trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType !='LUU_HO_SO') && (trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType !='DINH_CHI')}>
              <ShowIf condition={allowHandle && this.props.type != 'DA_GIAI_QUYET'}>
                <div className="wrap-link-todo"><Link className="itt-redirect" to={linkToHandle}>Xử lý</Link></div>
              </ShowIf>
              <ShowIf condition={
                this.props.tuGiaiQuyet &&
                this.props.type == 'DA_GIAI_QUYET' &&
                CheckQuyenTuXuLy(this.props.item.quyenTuXuLyInfo)
              }>
                <div className="wrap-link-todo"><Link className="itt-redirect" to={'/tu-giai-quyet-don/' + this.props.item.donId}>Tự xử lý</Link></div>
              </ShowIf>
              <ShowIf condition={this.props.type == 'DA_GIAI_QUYET' && this.props.item.canBoCoTheThuHoiInfo != null && this.props.item.canBoCoTheThuHoiInfo.giaTri == userInfo.id}>
                <TruongPhongThuHoiDialog id={donId} thongTinGiaiQuyetDonId={this.props.item.thongTinGiaiQuyetDonId} loaiDon={this.props.item.loaiDon} getListData={this.getListData.bind(this)}/>
              </ShowIf>
              <ShowIf condition={nguonDontype != 'GIAO_TTXM' && !this.props.item.dangGiaoKTDX && this.props.item.processType != 'THEO_DOI_THUC_HIEN' && (this.props.item.processType == 'GIAI_QUYET_DON' && trangThaiDon.length > 0 && trangThaiDon[0].trangThaiDonType !='DA_GIAI_QUYET')}>
                <ShowIf condition={this.props.item.loaiDon == 'DON_TO_CAO'}>
                  <GiaHanDialog id={donId} thongTinGiaiQuyetDonId={this.props.item.thongTinGiaiQuyetDonId} loaiDon={this.props.item.loaiDon} getListData={this.getListData.bind(this)}/>
                </ShowIf>
                <ShowIf condition={this.props.item.loaiDon != 'DON_KIEN_NGHI_PHAN_ANH' && !this.props.item.ma}>
                  <SuspendedDialog id={donId} loaiDon={this.props.item.loaiDon} getListData={this.getListData.bind(this)}/>
                </ShowIf>
              </ShowIf>
            </ShowIf>
            <ShowIf condition= {this.props.item.huongXuLyXLD != 'DINH_CHI' && this.checkQuyenBoSungThongTin() && (trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType =='LUU_HO_SO') && (trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType !='DINH_CHI')}>
              <div className="wrap-link-todo"><Link className="itt-redirect" to={'/bo-sung-thong-tin-giai-quyet-don/' + this.props.item.donId}>Bổ sung thông tin</Link></div>
            </ShowIf>
            <ShowIf condition={CheckPermission('GIAIQUYETDON_XOA') && showDelete}>
              <div className="mt10">
                <DeleteDialog
                  title={'Xoá đơn thư'}
                  content={'Bạn có đồng ý xóa đơn thư này không?'}
                  redux={this.props.parent}
                  deleteId={this.props.item.donId}
                />
              </div>
            </ShowIf>
          </div>
        </td>
      </tr>
    )
  }
}

ListTaiLieuRowItem.defaultProps = {
  dataLoaiDonThu: [],
  tuGiaiQuyet: false
}

let bindStateToProps = state => {
  return {
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  }
}

export default connect(bindStateToProps)(ListTaiLieuRowItem);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/datatable/rowItem/ListTaiLieuRowItem.jsx